// extracted by mini-css-extract-plugin
export default {"dotsOpen":"LocationBlock_dotsOpen__xzVNU"};